import api from "../../../../api";

export const fetchHubspotAuthUrl = async (brandgenAdvertiserId: string): Promise<string> => {
  const { payload } = await api.getHubspotAuth(brandgenAdvertiserId);
  return payload;
};

export const updateHubspotTokens = async (
  hubspotCredentialCode: string,
  brandgenAdvertiserId: string,
): Promise<void> => {
  await api.createHubspotTokens(hubspotCredentialCode, brandgenAdvertiserId);
};

export const deleteHubspotTokens = async (brandgenAdvertiserId: string): Promise<void> => {
  await api.deleteHubspotTokens(brandgenAdvertiserId);
};

export const redirectToHubspotAuth = async (brandgenAdvertiserId: string): Promise<void> => {
  const authUrl = await fetchHubspotAuthUrl(brandgenAdvertiserId);
  if (!authUrl) {
    throw new Error("HubSpot authorization URL is not available");
  }
  localStorage.setItem("currentBrandgenAdvertiserId", brandgenAdvertiserId);
  window.location.href = authUrl;
};
